export default __webpack_public_path__ + "static/media/ecoserve_logo_color.767163e9.png";